import React from 'react'
import Slider from "react-slick";

import './Roadmap.css'

const Roadmap = (props) => {
    const colorString = Object.values(props.theme).toString();
    var settings = {
        dots: false,
        infinite: false,
        speed: 500,
        slidesToShow: 3,
        slidesToScroll: 1,
        responsive: [
            {
              breakpoint: 991,
              settings: {
                slidesToShow: 2,
                slidesToScroll: 1
              }
            },
            {
              breakpoint: 600,
              settings: {
                slidesToShow: 1,
                slidesToScroll: 1
              }
            }

          ]
    };
    return (
        <section className={colorString === 'true'?`customSec dark`: `customSec whiteTheme`}>
            <h2 className="Head">ROADMAP</h2>
            <div className="container">
                <div className="scroller">
                    <div className="sectionHeading justify-content-center ml-md-4 mt-md-4 pr-md-3">
                        <div className="text-center">
                            <h3>Collect exclusive licensed NFTs of your favourite cricket stars.</h3>
                        </div>
                    </div>
                    <Slider {...settings}>

                    <div className="">
                            <div className="d-flex justify-content-center">
                                <div className="Quarter-1">
                                    Quarter 2, 2020
                                </div>
                            </div>
                            <div className='Roadmap-cont'>
                                <div className="Rectangle-44"></div>
                                <div className="Ellipse-290"></div>
                            </div>
                            <div className="roadmap-content">
                                <ul>
                                    <li>Idea Generation of Colexion </li>
                                    <li>Analysis of Existing Platforms</li>
                                </ul>
                            </div>
                        </div>
                        <div className="">
                            <div className="d-flex justify-content-center">
                                <div className="Quarter-1">
                                    Quarter 3, 2020
                                </div>
                            </div>
                            <div className='Roadmap-cont'>
                                <div className="Rectangle-44"></div>
                                <div className="Ellipse-290"></div>
                            </div>
                            <div className="roadmap-content">
                                <ul>
                                    <li>Announcement of Colexion Project</li>
                                    <li>Finalization of Market Research</li>
                                </ul>
                            </div>
                        </div>
                        <div className="">
                            <div className="d-flex justify-content-center">
                                <div className="Quarter-1">
                                    Quarter 4, 2020
                                </div>
                            </div>
                            <div className='Roadmap-cont'>
                                <div className="Rectangle-44"></div>
                                <div className="Ellipse-290"></div>
                            </div>
                            <div className="roadmap-content">
                                <ul>
                                    <li>Complete framework of Colexion</li>
                                    <li>Early development of Platform</li>
                                </ul>
                            </div>
                        </div>


                        <div className="">
                            <div className="d-flex justify-content-center">
                                <div className="Quarter-1">
                                    Quarter 1, 2021
                                </div>
                            </div>
                            <div className='Roadmap-cont'>
                                <div className="Rectangle-44"></div>
                                <div className="Ellipse-290"></div>
                            </div>
                            <div className="roadmap-content">
                                <ul>
                                    <li>Enter into Beta Testing Phase</li>
                                    <li>Complying ERC-721 Token Standard</li>
                                    <li>Implementation of Protocols and Key Properties</li>
                                </ul>
                            </div>
                        </div>
                        <div className="">
                            <div className="d-flex justify-content-center">
                                <div className="Quarter-1">
                                    Quarter 2, 2021
                                </div>
                            </div>
                            <div className='Roadmap-cont'>
                                <div className="Rectangle-44"></div>
                                <div className="Ellipse-290"></div>
                            </div>
                            <div className="roadmap-content">
                                <ul>
                                    <li>Beta Launch of Colexion</li>
                                    <li>Launch of CLXN Tokens</li>
                                    <li>Release of Whitepaper</li>
                                </ul>
                            </div>
                        </div>
                        <div className="">
                            <div className="d-flex justify-content-center">
                                <div className="Quarter-1">
                                    Quarter 3, 2021
                                </div>
                            </div>
                            <div className='Roadmap-cont'>
                                <div className="Rectangle-44"></div>
                                <div className="Ellipse-290"></div>
                            </div>
                            <div className="roadmap-content">
                                <ul>
                                    <li>Developing Visual Art and Gallery Beta Version</li>
                                    <li>Developing Virtual Music Album Beta Version</li>
                                    <li>Pre-Fund Raise of Colexion</li>
                                </ul>
                            </div>
                        </div>
                        <div className="">
                            <div className="d-flex justify-content-center">
                                <div className="Quarter-1">
                                    Quarter 4, 2021
                                </div>
                            </div>
                            <div className='Roadmap-cont'>
                                <div className="Rectangle-44"></div>
                                <div className="Ellipse-290"></div>
                            </div>
                            <div className="roadmap-content">
                                <ul>
                                    <li>Full-fledged launch of Virtual Art Gallery</li>
                                    <li>Launch of Virtual Museum Beta Version</li>
                                    <li>And</li>
                                </ul>
                            </div>
                        </div>



                        
                    </Slider>
                </div>
            </div>
        </section>
    )
}
export default Roadmap;